/**
 * Un 403 métier (profil privé, panier d'autrui) n'est pas une session expirée.
 * Seul un 401 hors routes /auth/ justifie un rafraîchissement de jeton.
 */
export function isRetriableAuthError(status, url) {
  if (status !== 401) return false
  if (typeof url === 'string' && url.includes('/auth/')) return false
  return true
}
